export const getLocale = (state) => state.locale.current;
export const getQueryLocale = (state) => state.locale.query;
